/* ==========================================================================
   Dekogreen PRO — comportamiento de las landings B2B.

   Solo hace dos cosas:
     1. Revelar bloques al entrar en viewport (IntersectionObserver, nunca un
        listener de scroll: ese se dispara en cada frame y hunde el móvil).
     2. Validar el formulario en línea antes de dejar que Shopify lo envíe,
        con el error debajo del campo y el foco puesto en el primero que falla.

   Se auto-inicializa una sola vez aunque varias secciones carguen el script,
   y se re-inicializa al recargar una sección en el personalizador.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__dkProInit) return;
  window.__dkProInit = true;

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1. Revelado al entrar en viewport
     --------------------------------------------------------------------- */
  var observer = null;

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.dkp-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    /* Solo ahora se permite ocultar: si este JS no llega a ejecutarse,
       el CSS deja el contenido visible. */
    Array.prototype.forEach.call(document.querySelectorAll('.dk-pro'), function (el) {
      el.classList.add('is-anim');
    });

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );
    }

    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
  }

  /* ---------------------------------------------------------------------
     2. Validación en línea del formulario de alta
     --------------------------------------------------------------------- */
  function clearError(field) {
    field.classList.remove('has-error');
    var input = field.querySelector('input, textarea');
    if (input) input.removeAttribute('aria-invalid');
    var msg = field.querySelector('.dkp-field__error[data-dkp-client]');
    if (msg) msg.remove();
  }

  function setError(field, text) {
    field.classList.add('has-error');
    var input = field.querySelector('input, textarea');
    if (input) input.setAttribute('aria-invalid', 'true');
    if (field.querySelector('.dkp-field__error[data-dkp-client]')) return;
    var p = document.createElement('p');
    p.className = 'dkp-field__error';
    p.setAttribute('data-dkp-client', '');
    p.textContent = text;
    field.appendChild(p);
  }

  function initForms(root) {
    var forms = (root || document).querySelectorAll('.dkp-form-card form:not([data-dkp-bound])');

    Array.prototype.forEach.call(forms, function (form) {
      form.setAttribute('data-dkp-bound', '');
      form.setAttribute('novalidate', '');

      form.addEventListener('submit', function (event) {
        var firstInvalid = null;

        Array.prototype.forEach.call(form.querySelectorAll('.dkp-field'), function (field) {
          var input = field.querySelector('input, textarea');
          if (!input) return;
          clearError(field);

          if (input.required && !input.value.trim()) {
            setError(field, 'Este campo es obligatorio.');
            if (!firstInvalid) firstInvalid = input;
          } else if (input.type === 'email' && input.value && !input.checkValidity()) {
            setError(field, 'Revisa el formato del correo.');
            if (!firstInvalid) firstInvalid = input;
          }
        });

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
          return;
        }

        var button = form.querySelector('button[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');
      });
    });
  }

  function init(root) {
    initReveal(root);
    initForms(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* El personalizador reinyecta el HTML de la sección sin recargar la página. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
